var $ = jQuery.noConflict();

$(document).ready(function () {

    // Auto-fill "Dagens datum" with current date (YYYY-MM-DD).
    var today = new Date();
    var yyyy  = today.getFullYear();
    var mm    = String(today.getMonth() + 1).padStart(2, '0');
    var dd    = String(today.getDate()).padStart(2, '0');
    var todayStr = yyyy + '-' + mm + '-' + dd;
    $('input[name="date_today"]').val(todayStr);

    // Restrict "Beställdes" to today or earlier.
    $('input[name="ordered_date"]').attr('max', todayStr);

    $('form.withdrawal-form').submit(function (e) {
        e.preventDefault();

        var $form   = $(this);
        var $button = $form.find('button[type="submit"]');

        if ($button.hasClass('inactive')) {
            return;
        }

        // Client-side validation before AJAX.
        var clientErrors = validateForm($form);
        if (clientErrors.length) {
            clearAlerts($form);
            handleErrors($form, { input: clientErrors });
            return;
        }

        $button.addClass('inactive');
        clearAlerts($form);

        $.ajax({
            url: withdrawalFormL10n.ajaxUrl,
            dataType: 'json',
            type: 'post',
            data: {
                action:        'withdrawal_form_submit',
                website:       $form.find('input[name="website"]').val(),
                date_today:    $form.find('input[name="date_today"]').val(),
                order_number:  $form.find('input[name="order_number"]').val(),
                full_name:     $form.find('input[name="full_name"]').val(),
                phone:         $form.find('input[name="phone"]').val(),
                address:       $form.find('input[name="address"]').val(),
                email:         $form.find('input[name="email"]').val(),
                goods:         $form.find('textarea[name="goods"]').val(),
                ordered_date:  $form.find('input[name="ordered_date"]').val(),
                received_date: $form.find('input[name="received_date"]').val(),
            },
            success: function (response) {
                if (response.status === 'success') {
                    $form.html(
                        '<div class="block-withdrawal-form__success">' +
                        response.message +
                        '</div>'
                    );
                } else {
                    handleErrors($form, response);
                    $button.removeClass('inactive');
                }
            },
            error: function () {
                $form.find('.block-withdrawal-form__alerts').html(
                    '<span class="alert error">' + withdrawalFormL10n.genericError + '</span>'
                );
                $button.removeClass('inactive');
            }
        });
    });

    /**
     * Clear all previous validation alerts and error classes.
     *
     * @param {jQuery} $form
     */
    function clearAlerts($form) {
        $form.find('.c-input-group').removeClass('error');
        $form.find('.alert').remove();
        $form.find('.block-withdrawal-form__alerts').empty();
    }

    /**
     * Show per-field and global error messages.
     *
     * @param {jQuery} $form
     * @param {Object} response
     */
    function handleErrors($form, response) {
        if (response.input && response.input.length) {
            $.each(response.input, function (i, err) {
                var $input = $form.find('[name="' + err.input + '"]');
                $input.closest('.c-input-group')
                    .addClass('error')
                    .append('<span class="alert error">' + err.message + '</span>');
            });
        }

        if (response.message) {
            $form.find('.block-withdrawal-form__alerts').html(
                '<span class="alert error">' + response.message + '</span>'
            );
        }
    }

    /**
     * Client-side field validation.
     *
     * @param {jQuery} $form
     * @return {Array} Array of error objects { input, message }.
     */
    function validateForm($form) {
        var errors = [];

        // Ärendenummer – only digits and an optional leading #, at least 4 digits.
        var orderVal = $.trim($form.find('input[name="order_number"]').val());
        if (orderVal) {
            if (!/^#?\d+$/.test(orderVal)) {
                errors.push({ input: 'order_number', message: withdrawalFormL10n.errorOrderNumber });
            } else if (orderVal.replace(/\D/g, '').length < 4) {
                errors.push({ input: 'order_number', message: withdrawalFormL10n.errorOrderNumberLength });
            }
        }

        // Phone – digits, spaces, hyphens, parentheses and leading +.
        var phoneVal = $.trim($form.find('input[name="phone"]').val());
        if (phoneVal && !/^[0-9+\-() ]{5,20}$/.test(phoneVal)) {
            errors.push({ input: 'phone', message: withdrawalFormL10n.errorPhone });
        }

        // Email – basic format check.
        var emailVal = $.trim($form.find('input[name="email"]').val());
        if (emailVal && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
            errors.push({ input: 'email', message: withdrawalFormL10n.errorEmail });
        }

        // Beställdes – today or earlier (string compare avoids UTC-parsing
        // pitfalls of new Date('YYYY-MM-DD'), which would flag today as future).
        var orderedVal = $form.find('input[name="ordered_date"]').val();
        if (orderedVal && orderedVal > todayStr) {
            errors.push({ input: 'ordered_date', message: withdrawalFormL10n.errorOrderedDate });
        }

        return errors;
    }
});
